import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityMissingDefaultShippingCostsResponse } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

const DEFAULT_PER_PAGE = 20;

export interface UseMissingDefaultShippingCostsParams {
  team_id?: number;
  page?: number;
  per_page?: number;
}

export const useMissingDefaultShippingCosts = (enabled: boolean, params?: UseMissingDefaultShippingCostsParams) => {
  const page = params?.page ?? 1;
  const perPage = params?.per_page ?? DEFAULT_PER_PAGE;
  const teamId = params?.team_id;

  return useQuery<ProfitabilityMissingDefaultShippingCostsResponse, Error>({
    queryKey: ['profitability', 'default-shipping-costs-missing', teamId ?? 'all', page, perPage],
    queryFn: () =>
      adapter.getMissingDefaultShippingCosts({
        team_id: teamId,
        page,
        per_page: perPage,
      }),
    enabled,
    staleTime: 30 * 1000,
  });
};
